import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { socialAuthAction } from 'src/store/actions/auth.actions';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import Loading from 'src/components/base/Loading';

// const isMobileWebview = () => {
//   const userAgent = navigator.userAgent;
//   return (
//     (/Android/i.test(userAgent) && /wv/i.test(userAgent)) ||
//     (/iPhone|iPad|iPod/i.test(userAgent) && !/Safari/i.test(userAgent))
//   );
// };

// const checkMobileDevice = () => {
//   // Check for mobile user agent
//   const userAgent = navigator.userAgent || navigator.vendor || window.opera;
//   const mobileRegex =
//     /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i;

//   // Check if we're in a WebView
//   const isInWebView =
//     window.navigator.standalone ||
//     window.matchMedia('(display-mode: standalone)').matches ||
//     userAgent.includes('wv');

//   return mobileRegex.test(userAgent) || isInWebView;

//   // setIsMobileDevice(mobileRegex.test(userAgent) || isInWebView);
// };

function AuthCallback() {
  const dispatch = useDispatch();
  const { push } = useHistory();
  const [userInfo, setUserInfo] = useState();
  const { isMobileDevice } = useSelector((state) => state.appSettingsReducer);

  useEffect(() => {
    // Extract the hash fragment from the URL
    const hash = window.location.hash.substring(1);
    const params = new URLSearchParams(hash);
    const idToken = params.get('id_token');

    if (idToken) {
      try {
        // Decode the JWT to get user info
        const decodedUserInfo = jwtDecode(idToken);

        setUserInfo(decodedUserInfo);

        if (isMobileDevice) {
          window.location.href = `dardiwan://auth-completed?email=${decodedUserInfo.email}`;
        } else {
          window.location.href = `${process.env.REACT_APP_APP_URL}/auth-completed?email=${decodedUserInfo.email}`;
        }
      } catch (error) {
        console.error('Error decoding token:', error);
        push('/error'); // Redirect to error page
      }
    } else {
      console.error('No id_token found in URL');
      push('/error');
    }
  }, [push]);

  return (
    <div className="">
      <Loading />
      <p style={{ color: 'blue' }}>
        Redirecting to {isMobileDevice ? 'Mobile' : 'website'}
      </p>
    </div>
    // <div>
    //  <p style={{ color: 'red', padding: '20px' }}>
    //     {checkMobileDevice() ? 'this is mobile device' : 'this is NOT mobile'}
    //   </p>
    //  <p>v1</p>
    //   <p>{JSON.stringify(userInfo, null, 2)}</p>
    // </div>
  );
}

export default AuthCallback;
